
import clients from '../api/clients'

export const state = {
  clients: [],
  client_pagination_data: {},
  client: ''
}

export const getters = {
  clients: state => state.clients,
  client_pagination_data: state => state.client_pagination_data,
  client: state => state.client
}

export const mutations = {
  ADD_CLIENT (state, data) {
    state.clients.push(data)
  },
  SET_CLIENTS (state, data) {
    data.map((client) => {
      client.emails = client.email.split(',')
    })
    state.clients = data

    console.log(state.clients)
  },
  SET_CLIENT_PAGINATION (state, data) {
    state.client_pagination_data = data
  },
  SHOW_CLIENT (state, data) {
    state.client = data
  }
}

export const actions = {
  GET_CLIENTS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      clients.get(data).then(response => {
        if (response.data.data) {
          commit('SET_CLIENTS', response.data.data)
          let paginationData = {
            from: response.data.from,
            to: response.data.to,
            total: response.data.total,
            last_page: response.data.last_page
          }
          commit('SET_CLIENT_PAGINATION', paginationData)
        } else {
          commit('SET_CLIENTS', response.data)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_CLIENT ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      clients.create(data).then(response => {
        commit('ADD_CLIENT', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_CLIENT ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      clients.show(id).then(response => {
        commit('SHOW_CLIENT', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_CLIENT ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      clients.update(data.data, data.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_CLIENT ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      clients.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  DEACTIVATE_CLIENT ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      clients.deactivate(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/clients.js